var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component, ViewChild } from '@angular/core';
import { GeneralPropertyAdapter } from './general/general-property.adapter';
import { GeneralPropertyDataToGoModelUtil } from './general/general-property-data-to-go-model-util';
import { BarGraphConsts } from './bar-graph-consts';
import { CalibrationDataToGoModelUtil } from '../shared/calibration-mark/calibration-data-to-go-model-util';
import { CalibrationGoModelToDataUtil } from '../shared/calibration-mark/calibration-go-model-to-data-util';
import { ResizableElementSettingModal } from '../base/resizable-element-setting-modal';
import { ExtendPropertyAdapter } from '../shared/extend-property/extend-property.adapter';
import { ExtendPropertyDataToGoModelUtil } from '../shared/extend-property/extend-property-data-to-go-model-util';
var BarGraphSettingModalComponent = /** @class */ (function (_super) {
    __extends(BarGraphSettingModalComponent, _super);
    function BarGraphSettingModalComponent(injector) {
        var _this = _super.call(this, injector, 'barGraphSettingModal') || this;
        _this.validateError = false;
        return _this;
    }
    BarGraphSettingModalComponent.prototype.onShown = function () {
        $(this.generalPropertyCmp.minValueInput.nativeElement).focus();
    };
    BarGraphSettingModalComponent.prototype.init = function (editedComponent) {
        var _this = this;
        this.configureId = editedComponent.configureId;
        this.addGoModelCompatible(editedComponent.model.data);
        this.generalData = new GeneralPropertyAdapter(editedComponent.model.data);
        this.extendData = new ExtendPropertyAdapter(editedComponent.model.data);
        this.calibrationMarkData = new CalibrationGoModelToDataUtil(editedComponent.model.data).toViewData();
        this.validateErrors = [false, false];
        _super.prototype.init.call(this, editedComponent);
        setTimeout(function () {
            _this.displaySettingCmp.init(editedComponent);
        }, 500);
        this.modal.show();
    };
    BarGraphSettingModalComponent.prototype.addGoModelCompatible = function (goModel) {
        if (!goModel.useAlarmLimit) {
            goModel.lowerLimit = BarGraphConsts.defaultLowerLimit;
            goModel.upperLimit = BarGraphConsts.defaultUpperLimit;
            goModel.lowerLimitColor = BarGraphConsts.defaultLowerLimitColor;
            goModel.upperLimitColor = BarGraphConsts.defaultUpperLimitColor;
        }
        if (!goModel.hasOwnProperty('barColor')) {
            goModel.barColor = '#6fd149';
            goModel.borderColor = '#808080';
            goModel.lowerLimitColor = '#0f60e8';
            goModel.upperLimitColor = '#ff4448';
            goModel.backgroundColor = BarGraphConsts.defaultBackgroundColor;
            goModel.calibrationDigitColor = BarGraphConsts.defaultCalibrationColor;
            goModel.percentageColor = BarGraphConsts.defaultCalibrationColor;
        }
        if (goModel.showScale === true) {
            if (!goModel.hasOwnProperty('showCalibrationDigit')) {
                goModel['showCalibrationDigit'] = true;
                goModel['calibrationDigitFontStyle'] = BarGraphConsts.defaultCalibrationDigitFont;
                if (!goModel.hasOwnProperty('integerDigits')) {
                    goModel.integerDigits = 3;
                }
                if (!goModel.hasOwnProperty('fractionDigits')) {
                    goModel.fractionDigits = 0;
                }
            }
            if (!goModel.hasOwnProperty('calibrationColor')) {
                goModel['calibrationColor'] = BarGraphConsts.defaultCalibrationColor;
            }
            if (goModel['showPercentage'] && !goModel.hasOwnProperty('percentageFontStyle')) {
                goModel['percentageFontStyle'] = BarGraphConsts.defaultCalibrationPercentageFont;
            }
        }
    };
    BarGraphSettingModalComponent.prototype.saveGeneralData = function () {
        new GeneralPropertyDataToGoModelUtil(this.currentDiagram, this.currentEditedPartData)
            .saveToGoJsModel(this.generalData);
    };
    BarGraphSettingModalComponent.prototype.saveExtendData = function () {
        new ExtendPropertyDataToGoModelUtil(this.currentDiagram, this.currentEditedPartData)
            .saveToGoJsModel(this.extendData);
    };
    BarGraphSettingModalComponent.prototype.saveCalibrationMark = function () {
        new CalibrationDataToGoModelUtil(this.currentDiagram, this.currentEditedPartData)
            .saveToGoJsModel(this.calibrationMarkData);
    };
    BarGraphSettingModalComponent.prototype.save = function () {
        if (this.calibrationMarkCmp) {
            if (!this.calibrationMarkCmp.validate()) {
                this.setActiveTab(2);
                return;
            }
        }
        this.saving = true;
        this.currentDiagram.startTransaction('barGraph settings');
        if (!this.displaySettingCmp.save()) {
            this.saving = false;
            this.setActiveTab(3);
            return;
        }
        this.saveGeneralData();
        this.saveExtendData();
        this.saveCalibrationMark();
        this.currentDiagram.commitTransaction('barGraph settings');
        this.close();
    };
    BarGraphSettingModalComponent.prototype.validateChange = function (validateResult, pageIndex) {
        var _this = this;
        this.validateError = false;
        this.validateErrors[pageIndex] = validateResult;
        this.validateErrors.forEach(function (error) {
            if (error) {
                _this.validateError = true;
            }
        });
    };
    BarGraphSettingModalComponent.prototype.setActiveTab = function (tabId) {
        this.staticTabs.tabs[tabId].active = true;
    };
    __decorate([
        ViewChild('displaySettingCmp', { static: false })
    ], BarGraphSettingModalComponent.prototype, "displaySettingCmp", void 0);
    __decorate([
        ViewChild('generalProperty', { static: false })
    ], BarGraphSettingModalComponent.prototype, "generalPropertyCmp", void 0);
    __decorate([
        ViewChild('calibrationMark', { static: false })
    ], BarGraphSettingModalComponent.prototype, "calibrationMarkCmp", void 0);
    __decorate([
        ViewChild('staticTabs', { static: false })
    ], BarGraphSettingModalComponent.prototype, "staticTabs", void 0);
    BarGraphSettingModalComponent = __decorate([
        Component({
            selector: 'bar-graph-setting-modal',
            template: "<div bsModal #settingModal=\"bs-modal\" id=\"barGraphSettingModal\" class=\"modal fade\" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"settingModal\" aria-hidden=\"true\" (onShown)=\"onShown()\" (onHidden)=\"onHidden()\" [config]=\"{backdrop: 'static'}\"> <div class=\"modal-dialog\"> <div class=\"modal-content\"> <div class=\"fe-modal-container\"> <form class=\"configure\" *ngIf=\"active\" #barGarphSettingForm=\"ngForm\" novalidate (ngSubmit)=\"save()\"> <div class=\"modal-header fe-modal-header\"> <h4 class=\"fe-modal-header-title\"> {{lc(\"BarGraph\")}} </h4> <div class=\"fe-modal-header-close\" aria-label=\"Close\" (click)=\"close()\">×</div> </div> <div class=\"top-line\"></div> <div class=\"fe-modal-middle design-nav-link\"> <tabset #staticTabs class=\"tab-container tabbable-line\"> <tab heading=\"{{lc('GeneralProperty')}}\" customClass=\"m-tabs__item\"> <general-property [configureId]=\"configureId\" #generalProperty [data]=\"generalData\" (validateChange)=\"validateChange($event,0);\"></general-property> </tab> <tab heading=\"{{lc('ExtendProperty')}}\" customClass=\"m-tabs__item\"> <extend-property [data]=\"extendData\" (validateChange)=\"validateChange($event,1);\"></extend-property> </tab> <tab heading=\"{{lc('CalibrationAndMarker')}}\" customClass=\"m-tabs__item\"> <calibration-mark #calibrationMark [data]=\"calibrationMarkData\" [displayPercentage]=\"true\"> </calibration-mark> </tab> <tab heading=\"{{lc('Display')}}\" customClass=\"m-tabs__item\" (selectTab)=\"tabSelected(controlSettingEventName,configureId)\"> <display-setting #displaySettingCmp [isAngle]='false'></display-setting> </tab> </tabset> </div> <div class=\"fe-modal-footer\"> <div class=\"button-group\"> <button type=\"submit\" class=\"fe-btn fe-btn-default fe-btn-save\" [disabled]=\"!barGarphSettingForm.form.valid || validateError\" [buttonBusy]=\"saving\" [busyText]=\"l('SavingWithThreeDot')\"> {{l(\"Save\")}} </button> <button [disabled]=\"saving\" type=\"button\" class=\"fe-btn fe-btn-default fe-btn-cancel-one\" (click)=\"close()\"> {{l(\"Cancel\")}} </button> </div> </div> </form> </div> </div> </div> </div>"
        })
    ], BarGraphSettingModalComponent);
    return BarGraphSettingModalComponent;
}(ResizableElementSettingModal));
export { BarGraphSettingModalComponent };
